export const LINK = {
  wixReview: `https://www.wix.com/app-market/add-review/${process.env.REACT_APP_APP_ID}`,
};
